import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass({'side-menu': true, 'd-flex': true, 'vertical': true, 'absolute-full-size': true})
}

import {WidgetStore} from "~/chat/ts/store/Widget";
import WidgetTab from "~/chat/vue/widget/WidgetTab.vue";
import SideMenuList from "~/chat/vue/widget/sideMenu/SideMenuList.vue";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "SideMenu"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let isOpened = WidgetStore.isSideMenuOpened;

function close() {
    WidgetStore.closeSideMenu();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "side-menu" }, {
    default: _withCtx(() => [
      (_unref(isOpened))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(WidgetTab, {
              back: false,
              "close-handler": close,
              title: _unref(__)('SELECT_ACTION'),
              "content-tab": ""
            }, {
              content: _withCtx(() => [
                _createVNode(SideMenuList, { onClose: close })
              ]),
              _: 1
            }, 8, ["title"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})